// extracted by css-extract-rspack-plugin
export default {"dimmed-value":"lMYc86","dimmedValue":"lMYc86","gems-cell":"yvtECO","gemsCell":"yvtECO","gems":"tbOaaf"};